<template>
  <div class="mb-4">
    <mdb-navbar color="indigo " dark position="top">
      <mdb-navbar-brand href="#" v-if="!isLogin">
        E-Ncs
      </mdb-navbar-brand>
      <mdb-navbar-toggler>
        <student-menu v-if="isStudent"/>
        <staff-menu v-if="isStaff || isTeacher"/>
        <mdb-navbar-nav right v-if="isLogin">
          <mdb-nav-item :to="{ name: 'Profile' }" icon="user-edit">{{profile.userId}}</mdb-nav-item>
          <mdb-nav-item @click="onLogout" icon="sign-out-alt">로그아웃</mdb-nav-item>
        </mdb-navbar-nav>
        <mdb-navbar-nav right v-else>
          <mdb-nav-item :to="{ name: 'Login' }" icon="sign-in-alt">로그인</mdb-nav-item>
          <mdb-nav-item :to="{ name: 'JoinOrg' }"  icon="user">회원가입</mdb-nav-item>
        </mdb-navbar-nav>
      </mdb-navbar-toggler>
    </mdb-navbar>
    <div v-if="isStaff" style="height:56px"/>
    <div v-else class="top-head pt-5 px-5 text-right text-white bolder"
        style="font-size:18px;text-shadow: -2px 0 black, 0 2px black, 2px 0 black, 0 -2px black;">
      <br>
      <span v-if="training._id">
        <mdb-icon icon="graduation-cap" />{{training.name}}
      </span>
    </div>
    <!-- 학생/선생의 경우 훈련명 서브 메뉴 -->
    <!-- <div class="my-3 mr-5 text-right lecture indigo-text"
      v-if="(isTeacher || isStudent) && training"  >
      <mdb-icon icon="graduation-cap" />{{training.name}}<br>
    </div> -->
    <!-- 어드민용 서브 메뉴 -->
    <div class="indigo lighten-1 py-2" v-if="isAdmin" v-show="active">
      <div class="container"><admin-training-select /></div>
    </div>
    <!-- 매니저용 서브 메뉴 -->
    <div class="indigo lighten-1 py-2" v-if="isManager" v-show="active">
      <div class="container"><manager-training-select /></div>
    </div>
  </div>
</template>
<script>
import { mdbNavbar, mdbNavbarBrand, mdbNavbarToggler, mdbNavbarNav, mdbNavItem, mdbDropdownMenu, mdbDropdownToggle, mdbDropdownItem } from 'mdbvue';
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
import AdminTrainingSelect from '../components/admin/AdminTrainingSelect.vue';
import ManagerTrainingSelect from '../components/manager/ManagerTrainingSelect.vue';
import loginMenu from '@/components/menu/LoginMenu';
import studentMenu from '@/components/menu/StudentMenu';
import staffMenu from '@/components/menu/StaffMenu';
import { LOGOUT } from '@/store/modules/auth/AuthType';
export default {
  name: 'Menu',
  components: { mdbNavbar, mdbNavbarBrand, mdbNavbarToggler, mdbNavbarNav, mdbNavItem, studentMenu, staffMenu, AdminTrainingSelect, ManagerTrainingSelect },
  computed: {
    ...mapState('auth', ['profile', 'org']),
    ...mapState('training', ['training']),
    ...mapGetters('auth', ['isLogin', 'isStudent', 'isStaff', 'isTeacher', 'isAdmin', 'isManager']),
    active () {
      const pages = [
        '/staff/proceeding',
        '/staff/test',
        '/staff/totalsummary',
        '/staff/regularcounsel',
        '/staff/dailylog',
        '/staff/notification',
        '/staff/board',
        '/staff/students'
      ]
      const path = this.$route.path
      for (let i = 0; i < pages.length; i++) {
        if (path.startsWith(pages[i])) {
          return true
        }
      }
      return false
    }
  },
  methods: {
    ...mapMutations('auth', ['clearAuth']),
    ...mapActions('auth', [LOGOUT]),
    ...mapMutations('training', ['clearTraining']),
    async onLogout () {
      await this.logout();
      this.clearAuth();
      this.clearTraining();
      this.$router.push({ name: 'Login' });
    }
  }
}
</script>
<style scoped>
.lecture {
  font-weight: 700;
}
</style>
